interface Props {
  slug: string;
  photos: string[];
}

/** Grid of photo thumbnails for an objekt. URLs are auth-gated; the browser
 * sends the session cookie automatically since they're same-origin. */
export function PhotoGallery({ slug, photos }: Props) {
  if (photos.length === 0) {
    return (
      <div
        className="rounded-lg border p-8 text-center"
        data-testid="photos-empty"
      >
        <p className="text-sm font-medium">Keine Fotos.</p>
        <p className="mt-1 text-xs text-muted-foreground">
          Fotos werden lokal über{" "}
          <code className="text-xs">make sync-photos SLUG={slug}</code>{" "}
          auf den Server hochgeladen.
        </p>
      </div>
    );
  }

  const baseUrl = `/api/objekte/${encodeURIComponent(slug)}/fotos`;

  return (
    <section className="space-y-2" data-testid="photo-gallery">
      <h2 className="text-sm font-medium text-muted-foreground">
        Fotos ({photos.length})
      </h2>
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {photos.map((name) => {
          const url = `${baseUrl}/${encodeURIComponent(name)}`;
          return (
            <li
              key={name}
              className="overflow-hidden rounded-md border"
              data-testid={`photo-${name}`}
            >
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Foto ${name} öffnen`}
              >
                <img
                  src={url}
                  alt={name}
                  loading="lazy"
                  className="h-32 w-full object-cover transition-transform hover:scale-105"
                />
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
